import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useQuery } from '@apollo/react-hooks';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Radio';
import Divider from '@material-ui/core/Divider';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ErrorMessage from '../ErrorMessage';

function ItemList({ items, value, onChange, name, valueKey, labelKey, title }) {
  return (
    <>
      <Typography
        variant='subtitle2'
        gutterBottom
        style={{ textAlign: 'center', fontWeight: 'bold' }}
      >
        {title}
      </Typography>
      <List
        dense
        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      >
        {items.map((item) => (
          <React.Fragment key={item[valueKey]}>
            <ListItem>
              <ListItemText primary={item[labelKey]} />
              <ListItemSecondaryAction>
                <Checkbox
                  edge='end'
                  onChange={() =>
                    onChange({ target: { value: item[valueKey], name } })
                  }
                  checked={value === item[valueKey]}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider component='li' />
          </React.Fragment>
        ))}
      </List>
    </>
  );
}

export default function SelectMultiple(props) {
  const [open, setOpen] = React.useState(false);
  const [optionsMap, setMap] = React.useState({});
  const { errors } = props;
  const hasErrors = errors && errors.length > 0;

  const onCompleted = (d) => {
    const optionsMap = d[props.dataKey].reduce((acc, curr) => {
      acc[curr[props.valueKey]] = curr;
      return acc;
    }, {});
    setMap(optionsMap);
  };

  const { loading, data } = useQuery(props.query, {
    variables: props.variables,
    onCompleted,
  });

  const handleOpen = () => {
    setOpen(true);
  };
  const values =
    props.value &&
    props.value
      .map((v) => (optionsMap[v] ? optionsMap[v] : null))
      .filter((v) => !!v);
  return (
    <>
      <Autocomplete
        disabled={props.disabled}
        multiple
        id={props.id}
        name={props.name}
        open={open}
        onOpen={handleOpen}
        onClose={() => {
          setOpen(false);
        }}
        getOptionLabel={(option) =>
          option[props.labelKey] ? option[props.labelKey] : ''
        }
        options={data ? data[props.dataKey] : []}
        loading={loading}
        value={values}
        onChange={(e, v) =>
          props.onChange({
            target: {
              name: props.name,
              value: v ? v.map((r) => r[props.valueKey]) : [],
            },
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            margin={props.margin}
            value={props.value}
            label={props.label}
            variant='outlined'
            error={hasErrors}
            helperText={<ErrorMessage errors={errors} />}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color='inherit' size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
      {values.length > 0 && props.mainProps && (
        <ItemList
          items={values}
          title={props.mainProps.title}
          name={props.mainProps.name}
          value={props.mainProps.value}
          valueKey={props.mainProps.valueKey}
          labelKey={props.mainProps.labelKey}
          onChange={props.mainProps.onchange}
        />
      )}
    </>
  );
}

SelectMultiple.defaultProps = {
  valueKey: 'id',
  labelKey: 'label',
};
